export function compare(a, b, field) {
  if (typeof a[field] === "string" && typeof b[field] === "string") {
    const aNormalize = a[field]
      .toLowerCase()
      .normalize("NFD")
      .replace(/[\u0300-\u036f]/g, "")
      .trim();
    const bNormalize = b[field]
      .toLowerCase()
      .normalize("NFD")
      .replace(/[\u0300-\u036f]/g, "")
      .trim();

    if (aNormalize < bNormalize) {
      return -1;
    }
    if (aNormalize > bNormalize) {
      return 1;
    }
  } else {
    if (a[field] < b[field]) {
      return -1;
    }
    if (a[field] > b[field]) {
      return 1;
    }
  }
  return 0;
}
